import React from 'react';
import { Header, Image, Divider } from 'semantic-ui-react';
import { ChoosePaymentMethod, PlanDetail } from '@emyw/pay-lib';
import '../custom-theme.css';
import { getLocalStorageWithExpiry } from '@emyw/core-lib';
import { getPlanCostLabel, DEFAULT_PROMO_CODE } from '../utils';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;

var Step3Payment = function Step3Payment(_ref) {
  var onPaymentMethodClick = _ref.onPaymentMethodClick,
      onChangePlanClick = _ref.onChangePlanClick,
      onValidatedPromoCode = _ref.onValidatedPromoCode,
      onInvalidPromoCode = _ref.onInvalidPromoCode,
      defaultPromoCode = _ref.defaultPromoCode,
      user = _ref.user,
      planSelectDisabled = _ref.planSelectDisabled,
      darkMode = _ref.darkMode,
      loadUser = _ref.loadUser,
      context = _ref.context;
  var subscriptionLevelName = user.subscriptionLevelName,
      verifiedOn = user.verifiedOn;
  var promoCode = getLocalStorageWithExpiry('enjoy-promo-code'); // let monthlyCostMessage;
  // if (promoCode === DEFAULT_PROMO_CODE) {
  //     promoCode = null;
  //     monthlyCostMessage = <i style={{ fontSize: '0.9em' }}>&nbsp;&nbsp;&nbsp;[first 7 days free]</i>;
  // }

  var monthlyCostMessage = /*#__PURE__*/React.createElement("i", {
    style: {
      fontSize: '0.9em'
    }
  }, /*#__PURE__*/React.createElement("br", null), "[first 7 days free]"); // const promoApplied = getLocalStorageWithExpiry('enjoy-promo-code') === DEFAULT_PROMO_CODE;

  var planMessage;
  var planCostLabel = getPlanCostLabel(user);

  if (planSelectDisabled) {
    planMessage = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, planCostLabel.label1, (planCostLabel.label1 || '').toLowerCase().indexOf('free') > -1 && /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, planCostLabel.label2, (planCostLabel.label2 || '').toLowerCase().indexOf('free') > -1 && /*#__PURE__*/React.createElement("sup", null, "*"))); // Show plan cost label here since PlanDetail won't be used below
  } else {
    // if (promoApplied) {
    planMessage = /*#__PURE__*/React.createElement("p", null, "Get first seven days free.");
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "wizardStepBase selectPayment"
  }, /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    size: "large",
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/circle-secure.png")
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepTitle"
  }, "Set up your payment.", /*#__PURE__*/React.createElement(Header.Subheader, null, verifiedOn && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), "Your account has been verified!"), !planSelectDisabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), "You're signing up for the ", /*#__PURE__*/React.createElement("b", null, subscriptionLevelName), " plan."), /*#__PURE__*/React.createElement("br", null), (verifiedOn || !planSelectDisabled) && /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("b", null, planMessage, "No commitments.", /*#__PURE__*/React.createElement("br", null), "Cancel online at any time.")))), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscribeStepContent"
  }, /*#__PURE__*/React.createElement(ChoosePaymentMethod, {
    onPaymentMethodClick: onPaymentMethodClick,
    user: user,
    showPromoCode: true,
    defaultPromoCode: defaultPromoCode,
    onValidatedPromoCode: onValidatedPromoCode,
    onInvalidPromoCode: onInvalidPromoCode,
    darkMode: darkMode,
    loadUser: loadUser,
    context: context
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), !planSelectDisabled && /*#__PURE__*/React.createElement(PlanDetail, {
    user: user,
    secondary: true,
    onChangePlanClick: onChangePlanClick,
    monthlyCostMessage: monthlyCostMessage
  }), promoCode && /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h3",
    textAlign: "left",
    style: {
      maxWidth: '450px',
      margin: '1em auto'
    }
  }, /*#__PURE__*/React.createElement(Header.Subheader, {
    style: {
      textAlign: 'center'
    }
  }, "* Promotion code ", promoCode, " applied!"))), /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center",
    style: {
      height: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "stepTitle"
  }, /*#__PURE__*/React.createElement(Header.Subheader, null, (planCostLabel.label2 || '').toLowerCase().indexOf('free') > -1 && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '0.85em'
    }
  }, /*#__PURE__*/React.createElement("sup", null, "*"), " No charges processed unless remaining on paid plan after trial.")))));
};

Step3Payment.defaultProps = {
  planSelectDisabled: false,
  darkMode: false
};
export default Step3Payment;